"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureShareOrderParams = void 0;
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const errors_1 = require("../../../interface/errors");
const CalculateUtils_1 = require("./CalculateUtils");
const trade_quotation_lib_1 = require("trade_quotation_lib");
var FutureShareOrderParams;
(function (FutureShareOrderParams) {
    const postShareOrderInfo = (data) => {
        const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().botTradeHost;
        const url = `${host}/apis/share/order`;
        let paramsStr;
        try {
            paramsStr = JSON.stringify(data);
        }
        catch (e) {
            console.warn(e);
            paramsStr = JSON.stringify({});
        }
        const p = {
            order_type: "futures",
            params: paramsStr,
        };
        return trade_utils_lib_1.Network.post({
            url,
            data: p,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, rxjs_1.map)((r) => {
            return {
                id: r.id,
                orderData: data,
                orderType: data.orderType,
            };
        }));
    };
    // 创建分享复制内容
    const createCopyData = ({ $st, id, orderData, inviteCode, }) => {
        // 多空方向
        const title = (function () {
            let trend;
            if (orderData.position_side === interface_1.FuturePositionSide.LONG) {
                trend = $st("trade_trend_long");
            }
            if (orderData.position_side === interface_1.FuturePositionSide.SHORT) {
                trend = $st("trade_trend_short");
            }
            if (orderData.position_side === interface_1.FuturePositionSide.BOTH) {
                trend = orderData.side === interface_1.CustomOrderSide.BUY ? $st("trade_trend_long") : $st("trade_trend_short");
            }
            const symbol = trade_quotation_lib_1.SymbolDataProvider.getSymbol(orderData.symbol);
            return `${trend ? `${trend} ` : ""}${symbol === null || symbol === void 0 ? void 0 : symbol.baseDisplay}/${symbol === null || symbol === void 0 ? void 0 : symbol.quoteDisplay} ${$st("futures_perpetual_short")}`;
        })();
        let content = title;
        // 市价单
        if (orderData.orderType === interface_1.FuturesOrderTypeUI.market) {
            content += `\n${$st("position_mode_open")}: ${$st("trade_market")}`;
        }
        // 限价单
        if (orderData.orderType === interface_1.FuturesOrderTypeUI.limit) {
            content += `\n${$st("position_mode_open")}: ${$st("trade_limit")} ${orderData.price}`;
        }
        // 条件单
        if (orderData.orderType === interface_1.FuturesOrderTypeUI.trigger) {
            content += `\n${orderData.trigger_price_type === interface_1.TriggerPriceType.LAST_PRICE
                ? $st("future_sk_last_price_trigger")
                : $st("future_sl_mark_price_trigger")}: ${orderData.trigger_price}`;
            if (orderData.type === interface_1.CustomOrderType.LIMIT) {
                content += `\n${$st("position_mode_open")}: ${$st("trade_limit")} ${orderData.price}`;
            }
            else {
                content += `\n${$st("position_mode_open")}: ${$st("trade_market")}`;
            }
        }
        // 分仓买卖
        if (orderData.orderType === "grid") {
            content += `\n${$st("grid_order_low")}: ${orderData.grid_low}`;
            content += `\n${$st("grid_order_high")}: ${orderData.grid_high}`;
            content += `\n${orderData.grid_type === "arithmetic"
                ? $st("grid_count_arithmetic_short", { count: orderData.grid_count })
                : $st("grid_count_geometric_short", { count: orderData.grid_count })}`;
        }
        // 止盈止损
        if (orderData.tpsl) {
            if (orderData.tpsl.tpPrice) {
                content += `\n${$st("label_tp")}: ${orderData.tpsl.tpPrice}`;
            }
            if (orderData.tpsl.slPrice) {
                content += `\n${$st("label_sl")}: ${orderData.tpsl.slPrice}`;
            }
        }
        const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().shareHost;
        const shareUrl = `${host}/copy/futures/${id}?inviteCode=${inviteCode}`;
        content += `\n\n${$st("futures_grid_follow_order_create_order")}\n${shareUrl}`;
        return (0, rxjs_1.of)(content);
    };
    // 验证
    const validateOrderData = (orderData, $st) => {
        // 限价单
        if (orderData.orderType === interface_1.FuturesOrderTypeUI.limit) {
            // 验证是否填写了价格
            if (new trade_utils_lib_1.SafeDecimal(orderData.price).equals(0)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_NO_LIMIT_PRICE);
            }
        }
        // 条件单
        if (orderData.orderType === interface_1.FuturesOrderTypeUI.trigger) {
            // 验证是否填写了 触发价
            if (new trade_utils_lib_1.SafeDecimal(orderData.trigger_price).equals(0)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_TRIGGER_PRICE_NONE);
            }
            // 限价模式下 是否填写了 价格
            if (orderData.type === interface_1.CustomOrderType.LIMIT && new trade_utils_lib_1.SafeDecimal(orderData.price).eq(0)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_NO_LIMIT_PRICE);
            }
        }
        // 分仓买卖
        if (orderData.orderType === "grid") {
            // 区间价格下限
            if (new trade_utils_lib_1.SafeDecimal(orderData.grid_low).eq(0)) {
                return (0, rxjs_1.throwError)($st("trade_input_param_please", { param: $st("grid_order_low") }));
            }
            // 区间价格上限
            if (new trade_utils_lib_1.SafeDecimal(orderData.grid_high).eq(0)) {
                return (0, rxjs_1.throwError)($st("trade_input_param_please", { param: $st("grid_order_high") }));
            }
            // 格子数量
            if (new trade_utils_lib_1.SafeDecimal(orderData.grid_count).eq(0)) {
                return (0, rxjs_1.throwError)($st("trade_input_param_please", { param: $st("gird_row_count") }));
            }
            if (new trade_utils_lib_1.SafeDecimal(orderData.grid_low).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(orderData.grid_high))) {
                return (0, rxjs_1.throwError)($st("gird_price_range_error"));
            }
        }
        return (0, rxjs_1.of)(orderData);
    };
    /**
     * 复制订单参数,仅支持开单，不支持减仓
     */
    FutureShareOrderParams.copyOrderParams = ({ orderData, inviteCode, $st, }) => {
        if (!orderData) {
            return rxjs_1.EMPTY;
        }
        const position_side = orderData.position_side
            ? orderData.position_side
            : orderData.positionMode && CalculateUtils_1.CalculateUtils.getPositionSide(orderData.positionMode, false, orderData.side);
        return validateOrderData(Object.assign(Object.assign({}, orderData), { position_side }), $st).pipe((0, rxjs_1.mergeMap)((data) => postShareOrderInfo(data)), (0, rxjs_1.mergeMap)((data) => createCopyData(Object.assign(Object.assign({}, data), { inviteCode, $st }))));
    };
})(FutureShareOrderParams = exports.FutureShareOrderParams || (exports.FutureShareOrderParams = {}));
